module.exports = function getResource(label) {
    const resources = { free: 'FREE' };

    return resources[label];
};
